module.exports = __webpack_public_path__ + "static/Spinner-7921d2a5788d13e1cfdaf393271f1267.gif";